import { combineReducers } from 'redux';
import {
  inviteTeamsActionTypes,
  manageTeamMembersActionTypes,
  manageTeamsActionTypes,
} from './ManageTeams.actionTypes';

const sendInviteInitialState = {
  pending: false,
  success: false,
  failure: false,
  successPayload: {},
  failurePayload: {},
};

const sendInviteReducer = (state = sendInviteInitialState, action) => {
  switch (action.type) {
    case inviteTeamsActionTypes.SEND_INVITE_PENDING:
      return {
        ...state,
        pending: true,
        success: false,
        failure: false,
        successPayload: {},
        failurePayload: {},
      };
    case inviteTeamsActionTypes.SEND_INVITE_SUCCESS:
      return {
        ...state,
        pending: false,
        success: true,
        failure: false,
        successPayload: action.payload,
        failurePayload: {},
      };
    case inviteTeamsActionTypes.SEND_INVITE_FAILED:
      return {
        ...state,
        pending: false,
        success: false,
        failure: true,
        successPayload: {},
        failurePayload: action.payload,
      };
    case inviteTeamsActionTypes.SEND_INVITE_CLEANUP:
      return {
        ...state,
        pending: false,
        success: false,
        failure: false,
        successPayload: {},
        failurePayload: {},
      };
    default:
      return {
        ...state,
      };
  }
};

const membersInitialState = {
  pending: false,
  success: false,
  failure: false,
  successPayload: {},
  failurePayload: {},
  updateEmployeeDetailsPending: false,
  updateEmployeeDetailsSuccess: false,
  updateEmployeeDetailsFailure: false,
  updateEmployeeDetailsFailurePayload: {},
  removeUserFromTeamPending: false,
  removeUserFromTeamSuccess: false,
  removeUserFromTeamFailure: false,
  removeUserFromTeamFailurePayload: {},
};

const membersReducer = (state = membersInitialState, action) => {
  switch (action.type) {
    case manageTeamMembersActionTypes.GET_MEMBERS_PENDING:
      return {
        ...state,
        pending: true,
        success: false,
        failure: false,
        successPayload: {},
        failurePayload: {},
      };
    case manageTeamMembersActionTypes.GET_MEMBERS_SUCCESS:
      return {
        ...state,
        pending: false,
        success: true,
        failure: false,
        successPayload: action.payload,
        failurePayload: {},
      };
    case manageTeamMembersActionTypes.GET_MEMBERS_FAILED:
      return {
        ...state,
        pending: false,
        success: false,
        failure: true,
        successPayload: {},
        failurePayload: action.payload,
      };
    case manageTeamMembersActionTypes.GET_MEMBERS_CLEANUP:
      return {
        ...state,
        pending: false,
        success: false,
        failure: false,
        successPayload: {},
        failurePayload: {},
      };
    case manageTeamMembersActionTypes.UPDATE_EMPLOYEE_DETAILS_PENDING:
      return {
        ...state,
        updateEmployeeDetailsPending: true,
        updateEmployeeDetailsSuccess: false,
        updateEmployeeDetailsFailure: false,
        updateEmployeeDetailsFailurePayload: {},
      };
    case manageTeamMembersActionTypes.UPDATE_EMPLOYEE_DETAILS_SUCCESS:
      return {
        ...state,
        updateEmployeeDetailsPending: false,
        updateEmployeeDetailsSuccess: true,
        updateEmployeeDetailsFailure: false,
        updateEmployeeDetailsFailurePayload: {},
      };
    case manageTeamMembersActionTypes.UPDATE_EMPLOYEE_DETAILS_FAILED:
      return {
        ...state,
        updateEmployeeDetailsPending: false,
        updateEmployeeDetailsSuccess: false,
        updateEmployeeDetailsFailure: true,
        updateEmployeeDetailsFailurePayload: action.payload || {},
      };
    case manageTeamMembersActionTypes.UPDATE_EMPLOYEE_DETAILS_CLEANUP:
      return {
        ...state,
        updateEmployeeDetailsPending: false,
        updateEmployeeDetailsSuccess: false,
        updateEmployeeDetailsFailure: false,
        updateEmployeeDetailsFailurePayload: {},
      };
    case manageTeamMembersActionTypes.REMOVE_USER_FROM_TEAM_PENDING:
      return {
        ...state,
        removeUserFromTeamPending: true,
        removeUserFromTeamSuccess: false,
        removeUserFromTeamFailure: false,
        removeUserFromTeamFailurePayload: {},
      };
    case manageTeamMembersActionTypes.REMOVE_USER_FROM_TEAM_SUCCESS:
      return {
        ...state,
        removeUserFromTeamPending: false,
        removeUserFromTeamSuccess: true,
        removeUserFromTeamFailure: false,
        removeUserFromTeamFailurePayload: {},
      };
    case manageTeamMembersActionTypes.REMOVE_USER_FROM_TEAM_FAILED:
      return {
        ...state,
        removeUserFromTeamPending: false,
        removeUserFromTeamSuccess: false,
        removeUserFromTeamFailure: true,
        removeUserFromTeamFailurePayload: action.payload || {},
      };
    case manageTeamMembersActionTypes.REMOVE_USER_FROM_TEAM_CLEANUP:
      return {
        ...state,
        removeUserFromTeamPending: false,
        removeUserFromTeamSuccess: false,
        removeUserFromTeamFailure: false,
        removeUserFromTeamFailurePayload: {},
      };
    default:
      return {
        ...state,
      };
  }
};

const teamsInitialState = {
  pending: false,
  success: false,
  failure: false,
  successPayload: {},
  failurePayload: {},
};

const teamsReducer = (state = teamsInitialState, action) => {
  switch (action.type) {
    case manageTeamsActionTypes.GET_TEAMS_PENDING:
      return {
        ...state,
        pending: true,
        success: false,
        failure: false,
        successPayload: {},
        failurePayload: {},
      };
    case manageTeamsActionTypes.GET_TEAMS_SUCCESS:
      return {
        ...state,
        pending: false,
        success: true,
        failure: false,
        successPayload: action.payload,
        failurePayload: {},
      };
    case manageTeamsActionTypes.GET_TEAMS_FAILED:
      return {
        ...state,
        pending: false,
        success: false,
        failure: true,
        successPayload: {},
        failurePayload: action.payload,
      };
    case manageTeamsActionTypes.GET_TEAMS_CLEANUP:
      return {
        ...state,
        pending: false,
        success: false,
        failure: false,
        successPayload: {},
        failurePayload: {},
      };
    default:
      return {
        ...state,
      };
  }
};
const manageTeamReducer = combineReducers({
  inviteTeam: sendInviteReducer,
  members: membersReducer,
  teams: teamsReducer,
});

export default manageTeamReducer;
